export const groupDataBasedOnPosition = (array, position) => {
  let newArray = [];
  let counter = 0;
  let size = 3;

  for (let i = position; i < array.length; i++) {
    if (counter < size) {
      counter++;
      newArray.push(array[i]);
    } else {
      break;
    }
  }

  return newArray;
};

export const calculateScore = (data, choices) => {
  let finalScore = 0;
  let array = [...data];

  array.pop();

  for (let i = 1; i < array.length; i++) {
    if (array[i].answer === choices[i].choice) {
      finalScore += array[i].points;
    }
  }

  return finalScore;
};

export const generateResultStructure = (length) => {
  let array = [];

  for (let i = 0; i < length - 1; i++) {
    array.push({ id: i, choice: null });
  }

  return array;
};

window.dev = () => {
  console.log("https://leonardomeza87.github.io/");
};
